export default "__VITE_ASSET__91572513__"